module.exports = __webpack_public_path__ + "static/media/microcentrifuge_topview_example.43194088.svg";